<script>
export default {
  name: 'FormError',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<template lang="pug">
.form-error
  .form-error__icon
    svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" <g fill="none" fill-rule="evenodd"><path d="M8 10c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" fill="#FFF"/><circle stroke="#FFF" stroke-width="2" cx="8" cy="8" r="7"/><rect fill="#FFF" x="7" y="4" width="2" height="5" rx="1"/></g>

  span.form-error__message {{ message }}
</template>

<style lang="stylus">
@import '../../assets/styles/modules/*'

.form-error
  background: THRIVA.colours.pink
  radius(sm)
  display: flex
  align-items: center
  min-height: 32px
  padding: 5px 10px
  margin-bottom: 15px
  line-height: 22px

  &__icon
    margin: 0 8px
    height: 16px
    width: 16px

  &__message
    color: THRIVA.colours.white
    font-weight: THRIVA.typography.font-weights.regular
</style>
